const breakpoints = {
    desktopXL: 1280,
    desktop: 1024,
    tablet: 768,
    mobile: 480,
} as const;

export const media = {
    desktopXL: `@media only screen and (max-width: ${breakpoints.desktopXL}px)`,
    desktop: `@media only screen and (max-width: ${breakpoints.desktop}px)`,
    tablet: `@media only screen and (max-width: ${breakpoints.tablet}px)`,
    mobile: `@media only screen and (max-width: ${breakpoints.mobile}px)`,
};
